import { createContext, useContext } from 'react';
export var PluginContext = createContext(undefined);
export function usePlugin() {
    return useContext(PluginContext);
}
//# sourceMappingURL=usePlugin.js.map